import {
	DpFanCardActionButtonSx,
	DpFanCardActionDescriptionSx,
	DpFanCardActionFrameSx,
	DpFanCardActionTitleSx,
} from '@/components/blocks/DpFanCardAction/styles';
import { DpButton } from '@/components/blocks/DpLibrary/DpButton';
import { Img } from '@/components/blocks/MaterialImage';
import { Box, Typography } from '@mui/material';
import { Fragment } from 'react';

export const DpFanCardAction = () => (
	<Fragment>
		<Box sx={DpFanCardActionFrameSx}>
			<Typography sx={DpFanCardActionTitleSx}>
				<Img src="/images/dpfan/icons/wand.svg" alt="wand" />
				{'UNETE A LA ZONA FAN'}
			</Typography>
			<Typography sx={DpFanCardActionDescriptionSx}>
				Cuéntanos tus tallas, equipos favoritos y más para personalizar tu experiencia.
				<DpButton component="a" variant="text" href="/quiz-dpfan" sx={DpFanCardActionButtonSx}>
					{'Comenzar'}
				</DpButton>
			</Typography>
		</Box>
	</Fragment>
);
